import Router from 'next/router';

// Track if a navigation is in progress
let isNavigating = false;

/**
 * Initialize router error handling
 */
export const initializeRouterErrorHandling = () => {
  if (typeof window === 'undefined') return;

  Router.events.on('routeChangeStart', () => {
    isNavigating = true;
    window.__navigationInProgress = true;
  });

  const handleRouteChangeComplete = () => {
    // Mark navigation as complete
    isNavigating = false;
    
    // Wait a bit before clearing the navigation flag to allow pending promises to resolve
    setTimeout(() => {
      window.__navigationInProgress = false;
    }, 300);
  };

  Router.events.on('routeChangeComplete', handleRouteChangeComplete);
  Router.events.on('routeChangeError', handleRouteChangeComplete);
};